var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#494B4C;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6,10v1h13v-1H6z M6,13v1h11v-1H6z M6,16v1h13v-1H6z M6,19v1h11v-1H6z M6,17h13v-1H6V17z M6,10v1h13v-1H6z  M6,20h11v-1H6V20z M17,13H6v1h11V13z M6,17h13v-1H6V17z M6,10v1h13v-1H6z M6,20h11v-1H6V20z M17,13H6v1h11V13z M22.8,1H19V0h-1v1 h-5V0h-1v1H7V0H6v1H2.2C1.6,1,1,1.6,1,2.2v21.5C1,24.4,1.6,25,2.2,25h20.5c0.7,0,1.2-0.6,1.2-1.2V2.2C24,1.6,23.4,1,22.8,1z  M23,23.8c0,0.1-0.1,0.2-0.2,0.2H2.2C2.1,24,2,23.9,2,23.8V7h21V23.8z M23,6H2V2.2C2,2.1,2.1,2,2.2,2H6v2h1V2h5v2h1V2h5v2h1V2h3.8 C22.9,2,23,2.1,23,2.2V6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.bbc22074451aa659da76e8d9614a84e2.svg";
export { ForwardRef as ReactComponent };